<template>
  <v-app>
    <transition name="fade-in-up">
      <manage-banner></manage-banner>
    </transition>
  </v-app>
</template>

<style lang="scss" scoped>
.theme--light.v-application {
  background: inherit;
}
</style>

<script>
import ManageBanner from "./ManageBanner";
export default {
  name: "Banner",
  components: { ManageBanner }
};
</script>
